// Número del despliegue publicado (se sube en cada publicación) y fecha en
// que se generó la versión (la pone sola craco.config.js al compilar).
export const DEPLOY_INFO = {
  number: 45,
  date: process.env.REACT_APP_BUILD_DATE,
};
